/** Key-metric tiles + two chart placeholders while the operations report computes. */

export default function OpsReportSkeleton() {
  return (
    <div className="rpt-shell-body" data-testid="ops-report-skeleton" aria-busy="true">
      <p className="ops-generating" data-testid="ops-report-generating">Generating report…</p>
      <section className="rpt-section">
        <h2 className="rpt-section-title">Key metrics</h2>
        <div className="rpt-kpi-grid">
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} className="rpt-kpi-card rpt-kpi-skel" />
          ))}
        </div>
      </section>
      <section className="rpt-section">
        <h2 className="rpt-section-title">Aging</h2>
        <div className="rpt-chart-skel" data-testid="ops-skel-chart-aging" />
      </section>
      <section className="rpt-section">
        <h2 className="rpt-section-title">Monthly</h2>
        <div className="rpt-chart-skel" data-testid="ops-skel-chart-monthly" />
      </section>
    </div>
  )
}
